export default "__VITE_ASSET__7uogG0C6__"